import {Injectable, Inject} from 'ng-metadata/core';




const uniq= require('lodash/uniq');

/*
This service acts as a proxy for accessing the local storage and provides redundancy using cookies
 in case local storage is not available (thank you very much Safari in private mode).

 Please!!!! use this service in order to access local storage and don't access it directly
*/
const LOCAL_STORAGE_PREFIX= 'LOCALSTORAGE'; //prefix added to every key saved to local storage so that we can identify in cookie mode that it was saved to local storage
const SESSION_STORAGE_PREFIX='SESSIONSTORAGE'; //prefix added to every key saved to session storage so that we can identify in cookie mode that it was saved to session storage
const BULK_PREFIX='Bulk';
const BULK_SUFFIX='@';
@Injectable()
export class StorageUtil implements IStorage{


    private _isLocalStorageAvailable: boolean= true;
    private _isSessionStorageAvailable: boolean= true;
    public localStorage: IStorage;
    public sessionStorage: IStorage;
    public $localForage: IStorage;
    constructor(@Inject ('$cookies') private $cookies,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$localForage') $localForage: ng.localForage.ILocalForageService) {
        try {
            localStorage.setItem("storageTest", "");
            localStorage.removeItem("storageTest");
        }
        catch (err) {
            this._isLocalStorageAvailable= false;
        }
        try{
            sessionStorage.setItem("storageTest", "");
            sessionStorage.removeItem("storageTest");
        }
        catch (err){
            this._isSessionStorageAvailable= false;
        }


        if (this._isLocalStorageAvailable){
            this.localStorage= localStorage;
            this.$localForage= $localForage;
        }
        else {
            this.localStorage= new cookieStorageWithBulking(LOCAL_STORAGE_PREFIX, this.$cookies);
            this.$localForage= new AsyncCookieStorageWithBulking(LOCAL_STORAGE_PREFIX, this.$cookies, this.$q);
        }

        if (this._isSessionStorageAvailable){
            this.sessionStorage= sessionStorage;
        }
        else{
            this.sessionStorage= new cookieStorageWithBulking(SESSION_STORAGE_PREFIX, this.$cookies);
        }

    }

    get isLocalStorageAvailable(){
        return this._isLocalStorageAvailable;
    }
    
    get isSessionStorageAvailable(){
        return this._isSessionStorageAvailable;
    }
    

}


class cookieBulkHandler{
    private MAX_COOKIE_SIZE= 2000;
    constructor(private prefix: string, private $cookies){

    }
    public splitToBulksAndSet(key: string, value: string) {
        this.removeBulkedItem(key); //first we need to remove the old value since there may be less bulks in the new value
        let stringifiedValue= JSON.stringify(value);
        let bulkSize= this.MAX_COOKIE_SIZE/ 2; //each character in JS is represented by 2 bytes
        let bulks= [];
        for (let i=0; i< stringifiedValue.length; i+= bulkSize){
            bulks[bulks.length]= stringifiedValue.slice(i, i+ bulkSize);
        }
        for (let bulkNum=0; bulkNum< bulks.length; bulkNum++){
            let indexedKey= this.prefix+ BULK_PREFIX + bulkNum + BULK_SUFFIX + key;
            this.$cookies.put(indexedKey, bulks[bulkNum]);
        }
    }

    public getBulkedItem(key: string) {
        let bulkNum=0;
        let stringifiedData= '';
        let bulk= this.$cookies.get(this.prefix + BULK_PREFIX + bulkNum + BULK_SUFFIX + key);
        while (bulk != undefined){
            stringifiedData+= bulk;
            bulkNum++;
            bulk= this.$cookies.get(this.prefix + BULK_PREFIX + bulkNum + BULK_SUFFIX + key);
        }
        if (bulkNum === 0){
            return undefined;
        }
        return JSON.parse(stringifiedData);
    }

    public removeBulkedItem(key: string) {
        let bulkNum=0;
        let bulk= this.$cookies.get(this.prefix + BULK_PREFIX + bulkNum + BULK_SUFFIX + key);
        while (bulk != undefined){
            this.$cookies.remove(this.prefix + BULK_PREFIX + bulkNum + BULK_SUFFIX + key);
            bulkNum++;
            bulk= this.$cookies.get(this.prefix + BULK_PREFIX + bulkNum + BULK_SUFFIX + key);
        }
    }
}

interface IStorage{
    setItem(key: string, value: string);
    removeItem(key: string);
    getItem(key: string);
    clear?();
    keys?();
}



class cookieStorageWithBulking implements IStorage{
    private cookieBulkHandler: cookieBulkHandler;
    constructor(private prefix: string, private $cookies){
        this.cookieBulkHandler= new cookieBulkHandler(prefix, $cookies);
    }
    public setItem(key: string, value: string) {
        this.cookieBulkHandler.splitToBulksAndSet(key, value);
    }

    public removeItem(key: string) {
        this.cookieBulkHandler.removeBulkedItem(key);
    }

    public getItem(key: string) {
        return this.cookieBulkHandler.getBulkedItem(key);
    }


}




class AsyncCookieStorageWithBulking implements IStorage{
    private cookieBulkHandler: cookieBulkHandler;
    constructor(private prefix: string , private $cookies, private $q: ng.IQService){
        this.cookieBulkHandler= new cookieBulkHandler(prefix, $cookies);
    }
    public setItem(key: string, value: string) {
        let isFailed= false;
        let error;
        try {
            this.cookieBulkHandler.splitToBulksAndSet(key, value);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(value);
            }
        });
    }

    public removeItem(key: string) {
        let isFailed= false;
        let error;
        try {
            this.cookieBulkHandler.removeBulkedItem(key);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve();
            }
        });
    }

    public getItem(key: string) {
        let isFailed= false;
        let error;
        let value;
        try {
            value= this.cookieBulkHandler.getBulkedItem(key);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(value);
            }
        });
    }

    public clear(){
        let isFailed= false;
        let error;
        try {
            let allCookies= this.$cookies.getAll();
            for (let key in allCookies) {
                if(key.indexOf(this.prefix) === 0){
                    this.$cookies.remove(key);
                }
            }
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve();
            }
        });
    }

    public keys(){
        let isFailed= false;
        let error;
        let keys;
        try {
            let allCookies= this.$cookies.getAll();
            keys= Object.keys(allCookies);
            keys= keys.filter((key)=>{
                return key.indexOf(this.prefix) === 0;
            });
            keys= keys.map((key)=>{
                return key.replace(new RegExp('^' + this.prefix),'');
            });
            keys= keys.map((key)=>{
                return key.replace(new RegExp('^' + BULK_PREFIX+ '\\d+' + BULK_SUFFIX),'');
            });
            keys= uniq(keys);

        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(keys);
            }
        });
    }

}




class cookieStorage implements IStorage{
    constructor(private prefix: string, private $cookies){

    }
    public setItem(key: string, value: string) {
        let keyWithPrefix= this.prefix + key;
        this.$cookies.put(keyWithPrefix, value);
    }

    public removeItem(key: string) {
        let keyWithPrefix= this.prefix + key;
        this.$cookies.remove(keyWithPrefix);
    }

    public getItem(key: string) {
        let keyWithPrefix= this.prefix + key;
        return this.$cookies.get(keyWithPrefix);
    }
}


class AsyncCookieStorage implements IStorage{
    constructor(private prefix: string , private $cookies, private $q: ng.IQService){

    }
    public setItem(key: string, value: string) {
        let isFailed= false;
        let error;
        let keyWithPrefix= this.prefix + key;
        try {
            this.$cookies.putObject(keyWithPrefix, value);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(value);
            }
        });
    }

    public removeItem(key: string) {
        let isFailed= false;
        let error;
        let keyWithPrefix= this.prefix + key;
        try {
            this.$cookies.remove(keyWithPrefix);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve();
            }
        });
    }

    public getItem(key: string) {
        let isFailed= false;
        let error;
        let value;
        let keyWithPrefix= this.prefix + key;
        try {
            value= this.$cookies.getObject(keyWithPrefix);
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(value);
            }
        });
    }

    public clear(){
        let isFailed= false;
        let error;
        try {
            let allCookies= this.$cookies.getAll();
            for (let key in allCookies) {
                if(key.indexOf(this.prefix) === 0){
                    this.$cookies.remove(key);
                }
            }
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve();
            }
        });
    }

    public keys(){
        let isFailed= false;
        let error;
        let keys;
        try {
            let allCookies= this.$cookies.getAll();
            keys= Object.keys(allCookies);
            keys= keys.filter((key)=>{
                return key.indexOf(this.prefix) === 0;
            });
            keys= keys.map((key)=>{
                return key.replace(new RegExp('^' + this.prefix),'');
            });
        }
        catch (err){
            isFailed= true;
            error= err;
        }
        return this.$q((resolve, reject)=>{
            if (isFailed){
                reject(error)
            }
            else{
                resolve(keys);
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/storageUtil.service.ts